import React from 'react';
import { CircleCheckIcon, GiftIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink px-0 py-16 sm:px-4 sm:py-20" aria-labelledby="bonuses-title" data-id="element-72" data-mp="1ckwkc887uhlx">
      <div className="mx-auto max-w-5xl" data-id="element-73" data-mp="18jun1wxv0fml">
        <div className="px-4 text-center sm:px-0" data-id="element-74" data-mp="18kw0g82cle7h">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-sm font-extrabold uppercase text-ink" data-id="element-75" data-mp="259lflqmlbspr">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="20btlcpyh3uie" />
            Free today
          </span>
          <h2 id="bonuses-title" className="mt-4 font-serif text-[32px] font-black leading-tight text-white sm:text-5xl" data-id="element-77" data-mp="1w7ub2p3sdrxh">
            Get these <span className="italic text-gold" data-id="element-78" data-mp="1rc6kc59noqpv">5 bonus tools</span> free with your purchase
          </h2>
          <p className="mt-4 text-[17px] text-white/80" data-id="element-79" data-mp="krniiahzd2c3">
            Perceived value: <span className="font-bold text-white line-through decoration-danger decoration-2" data-id="element-80" data-mp="ftcb06f5r3x1">$147</span> — included{' '}
            <strong className="text-gold" data-id="element-81" data-mp="1eru3epjicld7">FREE</strong> today.
          </p>
        </div>

        <div className="mt-12 space-y-8 sm:space-y-10" data-id="element-82" data-mp="1jqnigmeg0kfh">
          {bonuses.map((b, i) => <article key={b.number} className={`overflow-hidden bg-white sm:rounded-3xl md:grid md:grid-cols-2 md:items-center ${i % 2 === 1 ? 'md:[&>*:first-child]:order-2' : ''}`} data-id="element-83" data-mp="15sp6torib23o" data-mpi={i}>
              <div className="relative bg-cream" data-id="element-84" data-mp="10tvq7ngxauza">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-85" data-mp="10unoj61wn6t9" />
                <span className="absolute left-3 top-3 rounded-lg bg-ink px-3 py-1 text-sm font-black uppercase text-gold" data-id="element-86" data-mp="n4bsiw278nwu">
                  Bonus #{b.number}
                </span>
              </div>
              <div className="p-6 sm:p-8" data-id="element-87" data-mp="d6e6mf7tb37e">
                <h3 className="font-serif text-[26px] font-black leading-tight text-ink sm:text-3xl" data-id="element-88" data-mp="i3xhr697qzv4">{b.title}</h3>
                <p className="mt-2 flex items-center gap-3" data-id="element-89" data-mp="2jtlk3ofuc0i2">
                  <span className="text-lg font-bold text-muted line-through decoration-danger decoration-2" data-id="element-90" data-mp="2f1v71apiqymy">Value ${b.value}</span>
                  <span className="rounded-md bg-success px-2 py-0.5 text-sm font-black uppercase text-white" data-id="element-91" data-mp="2azgpctxl64x9">Free</span>
                </p>
                <p className="mt-4 text-[16px] leading-relaxed text-ink/80" data-id="element-92" data-mp="262zw5lbj50db">{b.text}</p>
                {b.items.length > 0 && <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-93" data-mp="2yq3whczogqir">
                    {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] leading-snug text-ink" data-id="element-94" data-mp="2tq83e8siqjhz">
                        <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-95" data-mp="2osg0kjqc5cz0" />
                        {item}
                      </li>)}
                  </ul>}
              </div>
            </article>)}
        </div>

        <div className="px-4 sm:px-0" data-id="element-96" data-mp="1392tqax42wl7">
          <SectionCta label="I want the system + 5 free bonuses" tone="dark" data-id="element-97" data-mp="13a44eea7th2e" />
        </div>
      </div>
    </section>;
}